import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "../components/loading/loading";
import Input from "../components/input/inputComponent";

import * as clientDataCollectActions from "./clientDataCollectActions";
import * as dropdownValuesActions from "../components/dropdownValues/dropdownValuesActions";
import * as saveFormDataActions from "../components/saveFormData/saveFormDataActions";
import * as routes from "../shared/routes";
import analytics from "../shared/analytics"
import * as caseSummaryActions from "../caseSummary/caseSummaryActions"
import Error from "../components/error/error"

class ClientDataCollect extends Component {
  constructor(props) {
    super(props);
    analytics.pageView();
    this.submitConfirmDialog = React.createRef();
    this.cancelButtonRef = React.createRef();
    this.cancelConfirmDialogRef = React.createRef();
    this.submitButtonRef = React.createRef();
    this.form = React.createRef();
    this.saveCallBack = this.saveCallBack.bind(this);
  }

  componentDidMount() {
    this.form.current.addEventListener('submit', () => this.submitHandler())
    this.form.current.addEventListener('error', (e) => console.error('error', e.detail.errors))

    this.props.onGetFormFields(
      this.props.actionId,
      this.props.projectId,
      this.props.screenId,
      this.props.token
    );

    this.props.onGetDropdownValues(this.props.screenId, this.props.token);

    this.cancelButtonRef.current.addEventListener('click', () => {
      this.cancelHandler()
    })

    this.cancelConfirmDialogRef.current.addEventListener('close', (e) => {
      this.handleCancelYesNoClick(e)
    })

    this.submitConfirmDialog.current.addEventListener('close', (e) => {
      if (e.detail.value) {
        this.handleEvent(e)
      }
    })
  }

  componentWillUnmount() {
    if (this.submitConfirmDialog.current) {
      this.submitConfirmDialog.current.removeEventListener("close", this);
    }
  }

  handleEvent = event => {
    if (event.type === "close" && event.detail) {
      if (event.detail.value) {
        this.saveData(true);
      }
    }
  }

  submitHandler = () => {
    this.submitConfirmDialog.current.show()
  }

  valueChangedHandler = (event, elementId, oldValue) => {
    let newValue = event.target.value;
    if (newValue !== oldValue) {
      this.props.onValueChanged(elementId, newValue);
    }
  };

  toggleBlurHandler = (event, elementId, oldValue) => {
    var checkedValue = event.target.checked ? "True" : "False";
    if (oldValue !== checkedValue) {
      this.props.onValueChanged(elementId, checkedValue);
    }
  };

  saveHandler = (e) => {
    this.saveData(false);
  };

  cancelHandler = () => {
    if (!this.props.isFieldsChanged) {
      this.props.history.push(routes.caseSummary);
    }
  }

  handleCancelYesNoClick(e) {
    if (e.detail.value) {
      this.props.onResetIsFieldChanged()
      this.props.history.push(routes.caseSummary);
    }
  }

  saveCallBack(isSubmit, hasSucced, errorMessage) {
    let type = null;
    let message = null;
    if (hasSucced) {
      type = "success";
      message = "Successfully Saved";
      if (isSubmit) {
        message = "Successfully Submitted";
      }
      showNotification(type, message);
      this.props.onClearCaseSummaryData();
      if (isSubmit) {
        this.props.history.push(routes.caseSummary);
      }
    } else {
      type = "danger";
      message = "Error saving : " + errorMessage;
      if (isSubmit) {
        message = "Error submitting : " + errorMessage;
      }
      showNotification(type, message);
    }
  }

  saveData(isSubmit) {
    const changedFields = this.props.fields.filter(
      field => field.elementId && field.value
    );

    const fieldAndValues = changedFields.map(element => {
      return { FQN: element.fqn, value: element.value };
    });

    analytics.trackEvent(
      {
        "key": "Save.Form",
        "segmentation": {
          "type": isSubmit ? "Submit" : "Save"
        }
      }
    );

    this.props.onSaveData(
      this.props.actionId,
      fieldAndValues,
      isSubmit,
      this.props.token,
      this.saveCallBack
    );
  }

  render() {
    if (this.props.error) {
      return Error(this.props.error);
    }
    let formContent = Loading();
    if (!this.props.loading) {
      formContent = this.props.fields.map(formElement => (
        <Input
          key={formElement.elementId}
          attributes={formElement}
        />
      ));
    }

    let disableSave = true;
    if (this.props.isFieldsChanged && !this.props.saving) {
      disableSave = false;
    }

    return (
      <mosaic-content-container>
        <mosaic-main-container fluid>
          <mosaic-page-header title={this.props.actionDescription} overflow />
          <mosica-row>
            <mosiac-card-body>
              <mosaic-col>
                <mosaic-card id="card1">
                  <mosaic-card-body>
                    <mosaic-form ref={this.form} prevent-default>
                      <div>{formContent}</div>

                      <mosaic-form-actions>
                        <mosaic-button
                          color="secondary"
                          dialog="alert-dialog"
                          ref={this.cancelButtonRef}>
                          Back
                      </mosaic-button>
                        <mosaic-button
                          color="secondary"
                          onClick={this.saveHandler}
                          disabled={disableSave}
                        >
                          Save
                      </mosaic-button>
                        <mosaic-button
                          color="primary"
                          ref={this.submitButtonRef}
                          submit
                        >
                          Submit
                      </mosaic-button>
                        <mosaic-dialog
                          color="danger"
                          header-title="Cancel"
                          id="alert-dialog"
                          dismiss-text="No"
                          confirm-text="Yes"
                          ref={this.cancelConfirmDialogRef}
                        >
                          <mosaic-icon
                            name="cancel"
                            width="48"
                            height="48"
                            class="m-1 mr-2 float-left fill-danger"
                          />
                          <p className="pt-3">
                            Are you sure you want to discard your changes?
                        </p>
                        </mosaic-dialog>
                        <mosaic-dialog
                          color="warning"
                          header-title="Confirm"
                          id="confirm-dialog"
                          dismiss-text="No"
                          confirm-text="Yes"
                          ref={this.submitConfirmDialog}
                        >
                          <mosaic-icon
                            name="error"
                            width="48"
                            height="48"
                            class="m-1 mr-2 float-left fill-warning"
                          />
                          <p className="pt-3">Are you sure you want to submit this form?</p>
                        </mosaic-dialog>
                      </mosaic-form-actions>
                    </mosaic-form>
                  </mosaic-card-body>
                </mosaic-card>
              </mosaic-col>
            </mosiac-card-body>
          </mosica-row>
        </mosaic-main-container>
      </mosaic-content-container>
    );
  }
}

const mapStateToProps = state => ({
  token: state.login.token,
  isClient: state.login.userType === 2,
  loading: state.clientDataCollect.loading,
  error: state.clientDataCollect.error,
  fields: state.clientDataCollect.fields,
  isFieldsChanged: state.clientDataCollect.isFieldsChanged,
  actionId: state.action.actionId,
  actionDescription: state.action.actionDescription,
  projectId: state.action.projectId,
  screenId: state.action.screenId,
  dropdownValues: state.dropdownValues.dropdownValues,
  saving: state.saveFormData.saving,
  submitted: state.saveFormData.submitted
});

const mapDispatchToProps = dispatch => {
  return {
    onGetFormFields: (actionId, matterId, screenId, token) =>
      dispatch(
        clientDataCollectActions.getFormFields(
          actionId,
          matterId,
          screenId,
          token
        )
      ),
    onValueChanged: (elementId, value) =>
      dispatch(clientDataCollectActions.fieldsValueChanged(elementId, value)),

    onSaveData: (actionId, fieldValue, isSubmit, token, showNotification) =>
      dispatch(
        saveFormDataActions.saveFormData(
          actionId,
          fieldValue,
          isSubmit,
          token,
          showNotification
        )
      ),
    onGetDropdownValues: (screenId, token) =>
      dispatch(dropdownValuesActions.getDropdownValues(screenId, token)),

    onClearCaseSummaryData: () =>
      dispatch(caseSummaryActions.clearCaseSummaryData()),

    onResetIsFieldChanged: () =>
      dispatch(clientDataCollectActions.resetIsFieldChanged())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientDataCollect);

function showNotification(type, message) {
  const nc = document.getElementById("notification-container");
  nc[type](message);
}
